import { render, staticRenderFns } from "./SlglrsPG2010_AllIssuesPage.vue?vue&type=template&id=e30cb25e&scoped=true&"
import script from "./SlglrsPG2010_AllIssuesPage.vue?vue&type=script&lang=js&"
export * from "./SlglrsPG2010_AllIssuesPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e30cb25e",
  null
  
)

export default component.exports